export const typeToName: {} = {
  hospital: '医療機関',
  doctor: '医師',
  patient: '顧客'
};

export const actionTypeToName: {} = {
  edit: '編集',
  add: '登録'
};



// WEBPACK FOOTER //
// ./src/constants/Dialog.tsx